import * as React from 'react'

import { Radio } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { FLOWS } from 'modules/contracts/components/FlowSelectorModal/constants'

import Label from '../Label'

interface Props {
  title: string
  value: string
  onChange: (option: React.SetStateAction<string>) => void
}

const UpdateRadioOption = ({ title, value, onChange }: Props) => {
  return (
    <Radio
      name={title}
      value={value}
      onChange={(option) => onChange(option)}
      description={i18n.t('contract_versions.modals.quick_flows.update.description')}
      option={{
        label: <Label icon="contract" text={title} />,
        value: FLOWS.evolution,
      }}
    />
  )
}

export default UpdateRadioOption
